
import { defineComponent, ref } from 'vue';
import { Form, defineRule } from 'vee-validate';
import ValidationService from '@/services/ValidationService';
import AppButton from '@/components/UI/AppButton.vue';
import AppInput from '@/components/UI/AppInput.vue';
import { CREATE_STEPS } from '@/types/enums';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
  },
  props: {
    dataLoading: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
  },
  setup(props, context) {
    const inputData = ref('');
    const schema = { groupName: 'required' };

    function nextStep() {
      context.emit('on-set-step', { value: inputData.value, step: CREATE_STEPS.INFO });
    }

    return {
      schema,
      inputData,
      nextStep,
    };
  },
});
